import he from 'he';
import Head from 'next/head';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import AllReviewsContainer from '@/components/route/listing/AllReviews/AllReviewsContainer';
import AllReviewsHeaderContainer from '@/components/route/listing/AllReviewsHeader/AllReviewsHeaderContainer';
import { PAGE_TITLE_SUFFIX } from '@/constants/pages';
import { getCampgroundListingData } from '@/redux/selectors/campgrounds/page';
import { getListingDescription, getListingTitle } from '@/redux/selectors/listing/page';

type TListingReviewsIndexProps = {
  rentalId?: string;
  isCampground?: boolean;
  isCampsite?: boolean;
  isStay?: boolean;
  isAuto?: boolean;
  error?: {
    statusCode?: number;
  };
};

const ListingReviewsIndex: React.FC<TListingReviewsIndexProps> = ({
  rentalId,
  isStay,
  isCampground,
  isCampsite,
  isAuto,
}) => {
  const intl = useIntl();
  const campground = useSelector(getCampgroundListingData);
  let title = useSelector(getListingTitle);
  let description = useSelector(getListingDescription);
  if (isCampground && campground) {
    title = intl.formatMessage(
      {
        defaultMessage: `Book Online Now at {campground} - in {locality}`,
        id: '4JFByw',
      },
      {
        campground: campground.name,
        locality: `${campground.location.city}, ${campground.location.state}`,
      },
    );

    description =
      campground.description.slice(0, 200) + (campground.description.length > 200 ? '...' : '');
  }

  return (
    <>
      <Head>
        <title>
          {title ? `Reviews | ${he.decode(title)}${PAGE_TITLE_SUFFIX}` : 'Reviews | Outdoorsy'}
        </title>
        <meta name="description" content={description} />
      </Head>
      <main className="bg-white">
        <div className="sticky top-0 z-10 w-full bg-white">
          <AllReviewsHeaderContainer
            isCampsite={isCampsite}
            isStay={isStay}
            isCampground={isCampground}
            isAuto={isAuto}
            className="grid grid-cols-main container-main gap-x-default"
          />
        </div>
        <div className="mb-32 grid grid-cols-main container-main gap-x-default mt-9 md:mt-14">
          <AllReviewsContainer listingId={rentalId} isStay={isStay} isCampground={isCampground} />
        </div>
      </main>
    </>
  );
};

export default ListingReviewsIndex;
